/// <amd-module name="Wit/UI/Components/IdentityView/IdentityView" />
import * as React from "react";
import { IVssPageContext } from "VSS/Platform/Context";
import { IdentityRef } from "VSS/Platform/Contracts/WebApi";
import { getIdentityImageUrl } from "VSS/Platform/Identity";
import { usePageContext } from "VSS/Platform/Layout";
import { getAssetLocation } from "VSS/Platform/Location";
import { Tooltip } from "VSSUI/TooltipEx";
import { css } from "VSSUI/Util";
import { VssPersona } from "VSSUI/VssPersona";
import { Identity_UnassignedUserIcon } from "Wit/UI/IdentityConstants";
import { Unassigned_Identity } from "Wit/UI/Resources.Identity";
import { IdentityDisplayMode } from "../../Enums";
import { IIdentityViewProps } from "./IdentityView.Props";

export function IdentityView(props: IIdentityViewProps) {
    const pageContext = usePageContext();

    const {
        viewMode = IdentityDisplayMode.AvatarAndName,
        className,
        size = "extra-extra-small",
        displayTextClassName,
        displayTooltipOnHover,
        suppressTooltip
    } = props;

    let { identityRef } = props;
    if (!identityRef || (!identityRef.id && !identityRef._links?.avatar?.href)) {
        identityRef = getUnassignedIdentityRef(pageContext, identityRef);
    }

    const displayName = identityRef.displayName;
    const isDisplayNameOnlyView = viewMode === IdentityDisplayMode.NameOnly;
    let imageUrl: string | undefined;
    if (!isDisplayNameOnlyView) {
        imageUrl = getIdentityImageUrl(pageContext, identityRef);
    }
    const toolTip = `${identityRef.displayName} <${identityRef.uniqueName}>`;
    const displayNameSpan = <span>{displayName}</span>;

    return (
        <div className={css("wit-ui-control identity-view", className)}>
            {imageUrl && !isDisplayNameOnlyView && (
                <VssPersona
                    size={size}
                    cssClass={"identity-avatar"}
                    identityDetailsProvider={{
                        getDisplayName: () => displayName,
                        getIdentityImageUrl: () => imageUrl
                    }}
                />
            )}
            {viewMode !== IdentityDisplayMode.AvatarOnly && (
                <div className={css("identity-display-name", displayTextClassName as string)}>
                    {!suppressTooltip ? (
                        <Tooltip text={toolTip} overflowOnly={!displayTooltipOnHover}>
                            {displayNameSpan}
                        </Tooltip>
                    ) : (
                        displayNameSpan
                    )}
                </div>
            )}
        </div>
    );
}

export function getUnassignedIdentityRef(pageContext: IVssPageContext, identityRef?: IdentityRef): IdentityRef {
    return {
        id: "",
        uniqueName: (identityRef && identityRef.uniqueName) || "",
        displayName: (identityRef && identityRef.displayName) || Unassigned_Identity,
        imageUrl: getAssetLocation(pageContext, Identity_UnassignedUserIcon)
    } as IdentityRef;
}
